class OrderSupplierQuote {
	constructor() {
		this.supplier = null
		this.dispatch_location = null
		this.order_items = []
		this.supplier_invoices = null

		this.supplier_po_amount = 0
		this.supplier_po_date = null
		this.supplier_po_document = null
		this.supplier_po_number = null
		this.supplier_po_status = null
		this.terms = `We declare that this invoice shows the actual price of the goods and all the particulars are true and correct.\n1. Interest upto 24% p.a. will be charged after a grace period of 7 days if the payment is not received as per the payment terms.\n2. Risk is transferred on delivery of goods to the party.\n3. All disputes are subject to Delhi Jurisdiction only.\n4. Weight Tolerance :- +/- 0.5% OF Invoiced Weight Visit www.metalbook.app / Download Metalbook app (Download App) to track your current order, see past invoices and orders with Metalbook, ledger and other details. COMPANY'S BANK DETAILS BANK NAME : Standard Chartered Bank A/C NO : 53105141407 IFSC CODE : SCBL0036025`

		// '1. PRICES ARE F.O.R AT SITE AND EXCLUSIVE OF TAXES\n2. ENDORSED TEST CERTIFICATES TO BE PROVIDED BEFORE DISPATCH\n3. WEIGHT TOLERANCE :- +/- 0.5% OF INVOICED WEIGHT\n4. DELIVERY CONDITIONS :- IMMEDIATE\n5. TCS IS NOT APPLICABLE, TDS TO BE CHARGED WHILE MAKING THE PAYMENT AGAINST THE BILLS.\n6. UNLOADING EXTRA UNDER THE SCOPE OF THE BUYER\n'

		// ADD MISSING KEYS

		this.order_supplier_id = null
		this.original_supplier_po_number = null
		this.supplier_po_documents = []

		this.quote_type = null
		this.logistics_quote_per_mt = 0
		this.lumpsum_logistics_quote = 0

		this.minimum_order_quantity = 0
		this.minimum_guaranteed_weight = 0

		this.message = ''
		this.order_ids = []
		this.enquiry_ids = []

		this.payment_terms_list = []
		this.tax_details = null
		this.other_charges = []

		this.billing_address = null
		this.oracle_id = null
		this.oracle_error = null

		this.estimate_pdf_id = null
		this.mbook_billing_address = null

		this.expected_delivery_date = null
		this.dispatch_start_date = null

		this.order_in_kgs = null
		this.consignee = null

		this.shipping_address = null
		this.expected_transit_time = null

		this.supply_margin = 0
		this.added_through_spo = false
		// addedkeys
		this.order_details = null
		this.delivery_region = null
		this.region = null
		this.platform = null
		this.supply_managers = null
	}
}

export default OrderSupplierQuote
